import type { CSSProperties } from 'react';

export type StyleProps<Value> = Value | (string & {});

export type OpdsStyleProps = {
  /** margin */
  m?: StyleProps<CSSProperties['margin']>;
  /** margin-top */
  mt?: StyleProps<CSSProperties['marginTop']>;
  /** margin-right */
  mr?: StyleProps<CSSProperties['marginRight']>;
  /** margin-bottom */
  mb?: StyleProps<CSSProperties['marginBottom']>;
  /** margin-left */
  ml?: StyleProps<CSSProperties['marginLeft']>;
  /** margin-inline */
  mx?: StyleProps<CSSProperties['marginInline']>;
  /** margin-block */
  my?: StyleProps<CSSProperties['marginBlock']>;
  /** margin-inline-end */
  me?: StyleProps<CSSProperties['marginInlineEnd']>;
  /** margin-inline-start */
  ms?: StyleProps<CSSProperties['marginInlineStart']>;

  /** padding */
  p?: StyleProps<CSSProperties['padding']>;
  /** padding-top */
  pt?: StyleProps<CSSProperties['paddingTop']>;
  /** padding-right */
  pr?: StyleProps<CSSProperties['paddingRight']>;
  /** padding-bottom */
  pb?: StyleProps<CSSProperties['paddingBottom']>;
  /** padding-left */
  pl?: StyleProps<CSSProperties['paddingLeft']>;
  /** padding-inline */
  px?: StyleProps<CSSProperties['paddingInline']>;
  /** padding-block */
  py?: StyleProps<CSSProperties['paddingBlock']>;
  /** padding-inline-start */
  ps?: StyleProps<CSSProperties['paddingInlineStart']>;
  /** padding-inline-end */
  pe?: StyleProps<CSSProperties['paddingInlineEnd']>;

  /** width */
  w?: StyleProps<CSSProperties['width']>;
  /** height */
  h?: StyleProps<CSSProperties['height']>;
  /** max-width */
  maw?: StyleProps<CSSProperties['maxWidth']>;
  /** max-height */
  mah?: StyleProps<CSSProperties['maxHeight']>;
  /** min-width */
  miw?: StyleProps<CSSProperties['minWidth']>;
  /** min-height */
  mih?: StyleProps<CSSProperties['minHeight']>;

  /** color */
  c?: StyleProps<CSSProperties['color']>;
  /** background */
  bg?: StyleProps<CSSProperties['background']>;
  /** border */
  bd?: StyleProps<CSSProperties['border']>;

  /** font-size */
  fz?: StyleProps<CSSProperties['fontSize']>;
  /** line-height */
  lh?: StyleProps<CSSProperties['lineHeight']>;
  /** font-family */
  ff?: StyleProps<CSSProperties['fontFamily']>;
  /** font-weight */
  fw?: StyleProps<CSSProperties['fontWeight']>;
  /** text-align */
  ta?: StyleProps<CSSProperties['textAlign']>;
  /** text-decoration */
  td?: StyleProps<CSSProperties['textDecoration']>;
  /** text-transform */
  tt?: StyleProps<CSSProperties['textTransform']>;

  /** opacity */
  opacity?: StyleProps<CSSProperties['opacity']>;
  /** flex */
  flex?: StyleProps<CSSProperties['flex']>;
};

export const stylePropsMap: Record<keyof OpdsStyleProps, string> = {
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginInline',
  my: 'marginBlock',
  me: 'marginInlineEnd',
  ms: 'marginInlineStart',

  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingInline',
  py: 'paddingBlock',
  ps: 'paddingInlineStart',
  pe: 'paddingInlineEnd',

  w: 'width',
  h: 'height',
  maw: 'maxWidth',
  mah: 'maxHeight',
  miw: 'minWidth',
  mih: 'minHeight',

  c: 'color',
  bg: 'background',
  bd: 'border',

  fz: 'fontSize',
  lh: 'lineHeight',
  ff: 'fontFamily',
  fw: 'fontWeight',
  ta: 'textAlign',
  td: 'textDecoration',
  tt: 'textTransform',

  opacity: 'opacity',
  flex: 'flex',
};
